<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    :label-position="labelPosition"
    enctype="multipart/form-data"
  >
    <span v-if="rabotaRuWarningText" class="rabota-ru-warning">
      <span> <Icon iconName="Warning" /></span>
      <span>
        При публикации на портале ТрудВсем обнаружена ошибка:
        {{ rabotaRuWarningText | format }}</span
      >
    </span>
    <template v-if="metaData.hidden_fields">
      <input
        v-if="!defaultParams.email_id"
        type="hidden"
        name="record"
        :value="form.record"
      />
      <input
        v-for="field in metaData.hidden_fields"
        :key="field.name"
        type="hidden"
        :name="field.name"
        :value="field.value"
      />
    </template>
    <div
      v-for="(panel, i) in metaData.panels"
      :key="panel.panel_id"
      class="form-panel"
      :class="
        form.work_site == 'rabotaru' && panel.panel_id == 'LBL_SETTINGS_VACANCY'
          ? 'form-panel--special'
          : ''
      "
    >
      <div class="flex-row">
        <p v-if="panel.lbl" class="block-title fw-500 primary">
          {{ panel.lbl }}
        </p>
        <Tooltip
          :content="
            panel.info || 'Указывайте адрес с точностью до корпуса/строения'
          "
          :disabled="!panel.icon"
        >
          <Picture class="block-img" v-if="panel.icon" :url="panel.icon" />
        </Tooltip>

        <div
          v-if="
            panel.panel_id == 'LBL_SOCIAL_PACKET_PANEL' ||
            panel.panel_id == 'LBL_PREMIUM_BONUSES_PANEL'
          "
          class="form-panel__arrow"
          @click="collapse(panel.panel_id)"
        >
          <Icon
            :iconName="
              collapsedPanels[panel.panel_id] ? 'ArrowUp' : 'ArrowDown'
            "
            iconColor="#788694"
          />
        </div>
      </div>

      <div
        v-if="panel.panel_id !== 'LBL_COMMUNICATIONS'"
        v-show="!collapsedPanels[panel.panel_id]"
      >
        <div
          class="panel-row"
          v-for="(row, index) in panel.rows"
          :key="index"
          :class="{ 'panel-row--switch': switcherField(row[0]) }"
        >
          <template v-for="(field, j) in row">
            <div
              :key="field.label"
              v-if="!field.name && field.type === 'html_label'"
              v-html="$sanitize(field.lbl)"
            ></div>
            <Button
              class="button-admin"
              v-else-if="field.type === 'link'"
              :key="field.label"
              :buttonText="field.lbl"
              disabled
              buttonSize="big"
            />
            <div
              v-else-if="field.type == 'file'"
              class="email-attachment"
              :key="field.label"
            >
              <p class="el-form-item__label email-attachment__title">
                {{ field.lbl }}
              </p>
              <Upload
                ref="upload"
                class="email-attachment__uploader"
                :file="files"
                :multiple="true"
                :show-file-list="true"
                @upload-file="updateFileList"
                @remove-file="updateFileList"
              />
            </div>
            <span v-else-if="!field.name" :key="field.name"></span>
            <form-field
              v-else-if="!hidden(field) && !blocked[field.name]"
              :key="`${i}_${index}_${j}_${field.name}`"
              :item="field"
              :form="form"
              :module="defaultParams.module"
              :is-popup="true"
              :noRequiredStar="noRequiredStar"
              :datepicker="datepicker"
              :options="options"
              :blocked="blocked"
              :callback="callback"
              :field-size="fieldSize"
              :visible-option-btn="visibleSkillBtn"
              @set-value="setFieldValue"
              @change-option="changeOption"
              @save-form="saveForm('form', defaultParams.work_site)"
              @add-new-option="v => addNewSkill(v, field.front_field_type)"
              @get-intent="getIntentHandler"
            ></form-field>
          </template>
        </div>
      </div>
      <div v-else :key="formKey">
        <div
          class="panel-row"
          v-for="(row, index) in mutationMetaDataPanels"
          :key="index"
          :class="{ 'panel-row--switch': switcherField(row[0]) }"
        >
          <template v-for="(field, j) in row">
            <span v-if="!field.name" :key="field.name"></span>
            <form-field
              v-else-if="!hidden(field) && !blocked[field.name]"
              :key="`${i}_${index}_${j}_${field.name}`"
              :item="field"
              :form="form"
              :module="defaultParams.module"
              :is-popup="true"
              :noRequiredStar="noRequiredStar"
              :datepicker="datepicker"
              :options="options"
              :blocked="blocked"
              :callback="callback"
              :field-size="fieldSize"
              :visible-option-btn="visibleSkillBtn"
              @set-value="setFieldValue"
              @change-option="changeOption"
              @save-form="saveForm('form', defaultParams.work_site)"
              @add-new-option="v => addNewSkill(v, field.front_field_type)"
              @get-intent="getIntentHandler"
            ></form-field>
          </template>
        </div>
      </div>
    </div>

    <slot name="bottom-content"></slot>
    <div v-show="metaData.custom_panels" class="custom-panels">
      <div
        v-for="panel in metaData.custom_panels"
        :key="panel.switcher_fields"
        class="custom-panels__item panel"
        :id="panel.switcher_fields"
      >
        <div class="custom-panels__switcher panel__header">
          <Switcher
            :model="form[panel.switcher_fields] == '1'"
            @switch="
              val => {
                $set(form, panel.switcher_fields, String(+val));
                if (panel.switcher_fields == 'email_switcher') {
                  $emit('emailSwitch', val);
                }
              }
            "
          />
          <p class="custom-panels__label panel__label">
            {{ panel.lbl || '[нет имени]' }}
          </p>
          <slot name="email-form"></slot>
        </div>
        <div
          v-if="
            panel.switcher_fields == 'switcher_files' &&
            panel.rows &&
            form[panel.switcher_fields] == 1
          "
        >
          <div
            class="panel-row custom-panels__row"
            v-for="(row, index) in panel.rows"
            :key="index"
          >
            <div
              v-for="(field, j) in row"
              :key="`${index}_${j}`"
              :class="[
                `panel-row__column`,
                j == 0 ? `panel-row__column--left` : `panel-row__column--right`
              ]"
            >
              <span v-if="!field.name" :key="field.name"></span>
              <form-field
                v-else-if="!hidden(field) && !blocked[field.name]"
                :key="`${index}_${j}_${field.name}`"
                :item="field"
                :form="form"
                :module="defaultParams.module"
                :is-popup="false"
                :noRequiredStar="noRequiredStar"
                :datepicker="datepicker"
                :options="options"
                :blocked="blocked"
                :callback="callback"
                :field-size="fieldSize"
                :visible-option-btn="visibleSkillBtn"
                @set-value="setFieldValue"
                @update-documents-list="updateDocumentsList"
                @change-option="changeOption"
                @save-form="saveForm('form')"
                @add-new-option="v => addNewSkill(v, field.front_field_type)"
                @get-intent="getIntentHandler"
              ></form-field>
            </div>
          </div>
          <SubpanelTable
            v-if="documents.length"
            :tableColumns="tableColumns"
            v-loading="removeFile_loading"
            :tableData="documents"
            :height="documents.length == 1 ? '101' : '146'"
            :allowDelete="true"
            :user-id="form.record"
            class="documents-list"
            module="Notes"
            @downloadFile="downloadDocument"
            @handleDelete="removeDocument"
          />
        </div>
      </div>
    </div>

    <form-buttons
      v-if="metaData.buttons_menu && metaData.buttons_menu.length && !noButtons"
      v-scroll="handleScroll"
      v-loading="loading"
      :disabledBtns="
        type == 'offer' && !form['template_name']
          ? { preview: true, save_and_download: true }
          : {}
      "
      :buttons_menu="metaData.buttons_menu"
      :view-type="formView"
      @get-intent="getIntentHandler"
    />
  </el-form>
</template>

<script>
import { getController, postController } from '@/controllers/request.js';
import { store } from '@/store';
import { ACTION, FIELD, MODULE } from '@/utils/constants';
import {
  scrollToError,
  setDateFormat,
  unmaskedPhone,
  base64ToBlob,
  downloadFile,
  previewFile
} from '@/utils/helpers';
import {
  errorMsg,
  form,
  metadata,
  mixin,
  parseIntent,
  rules,
  saveForm
} from '@/utils/mixins';
import Button from 'Elements/Button/Button';
import FormButtons from 'Elements/Form/FormButtons';
import FormField from 'Elements/Form/FormField';
import Icon from 'Elements/Icon/Icon';
import Picture from 'Elements/Picture/Picture';
import Switcher from 'Elements/Switch/Switch';
import SubpanelTable from 'Elements/Table/SubpanelTable';
import Tooltip from 'Elements/Tooltip/Tooltip';
import Upload from 'Elements/Upload/Upload';
import { Form } from 'element-ui';

export default {
  mixins: [mixin, rules, metadata, form, saveForm, parseIntent, errorMsg],
  props: {
    data: {
      type: Object,
      default: null
    },
    defParams: {
      type: Object,
      default: () => ({})
    },
    files: {
      // прикрепленные файлы в форме
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    },
    buttonsMeta: {
      type: Array,
      default: () => []
    },
    noButtons: {
      // не показывать кнопки по метаданным
      type: Boolean,
      default: false
    },
    labelPosition: { type: String, default: 'top' },
    fieldSize: {
      type: String,
      default: 'medium'
    },
    noRequiredStar: Boolean,
    loadedAction: {
      type: String,
      default: ACTION.GET_EDITVIEW
    },
    isEmailForm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultParams: this.defParams,
      tableColumns: {
        filename: {
          lbl: {
            value: 'Файл'
          }
        },
        date_entered: {
          lbl: {
            value: 'Дата и время загрузки'
          }
        },
        created_by_name: {
          lbl: {
            value: 'Автор'
          }
        }
      },

      log: 0,
      formKey: 0,
      FIELD,
      formView: 'popup', // для миксина сохранения формы
      fields: {},
      btnLoading: {
        preview: false,
        save_download: false
      },
      datepicker: {
        dateFormat: 'dd.MM.yyyy',
        timeFormat: 'HH:mm'
      },
      documents: [],
      removeFile_loading: false,
      loading: false,
      form: {},
      options: {},
      skills: {}, // для новых навыков
      fieldLoading: false,
      visibleSkillBtn: false,
      rules: {},
      metaData: {},
      blocked: {},
      collapsedPanels: {},
      callback: {
        field: {
          change: (field, val) => {
            switch (field.name) {
              case FIELD.ID.SALARY_MIN:
              case FIELD.ID.SALARY_MAX:
              case FIELD.ID.SALARY_FROM:
              case FIELD.ID.SALARY_TO:
                this.formatSalary(val, field.name, field.precision);
                break;

              case FIELD.ID.VACANCY_NAME:
                this.$nextTick(() =>
                  this.$emit(
                    'select-vacancy',
                    this.form[field.id_name.name],
                    this.form.date_start
                  )
                );
                this.$nextTick(() => this.$emit('emailSwitch', false));
                break;
              case FIELD.ID.CANDIDATE_NAME:
                this.$nextTick(() => this.$emit('emailSwitch', false));
                break;
              case 'date_event':
                this.$emit('update-date', val);
                break;

              case 'calendar_type':
                this.$emit('update-slots', val);
                break;

              default:
                break;
            }
          },
          input: (field, e, access) => {
            switch (field.name) {
              case 'key_skills':
                this.handleChangeSkill(
                  e,
                  field.name,
                  field[FIELD.PARAM.MULTIPLE_LIMIT],
                  access
                );
                break;

              default:
                break;
            }
          },
          visibleChange: (field, bool) => {
            switch (field.name) {
              case 'key_skills':
                this.handleBlur(bool, field.name);
                break;

              default:
                break;
            }
          }
        }
      },
      initialForm: {},
      rabotaRuWarningText: '',
      bean: null
    };
  },
  created() {
    if (
      !this.isEmailForm ||
      (this.isEmailForm && this.defaultParams.parent_id)
    ) {
      getController({
        params: {
          ...this.defaultParams,
          action: this.loadedAction,
          to_pdf: true
        }
      })
        .then(resp => {
          if (!resp?.data || typeof resp.data !== 'object') return;

          const { bean, metadata, metaData, user_dat_format, message, status } =
            resp.data;

          if (!metadata && message && status) {
            this.$emit('reset-callback');
            store.dispatch('common/catchError', { msg: message });
            return;
          }
          this.bean = bean;
          const record = bean.id.value;
          const meta = metadata || metaData;

          if (
            !this.defaultParams.email_id &&
            this.defaultParams.module != MODULE.HRPAC_COORDINATION_REQUESTS
          ) {
            this.$set(this.form, 'record', record);
          }

          if (bean?.published_at?.value) {
            this.$set(this.form, 'published_at', bean.published_at.value);
          }

          if (this.defaultParams.module == MODULE.HRPAC_EVENT) {
            this.$set(this.form, 'event_id', record);
            this.$emit('get-busy-slots', {
              date_event:
                bean?.date_event?.value ||
                bean?.date_start?.value.split(' ')[0],
              calendar_type: bean.calendar_type.value
            });
          }

          if (
            this.defaultParams.module === MODULE.HRPAC_EVENT &&
            !this.defaultParams.event_id
          ) {
            this.$emit('add-member', bean.current_user.value);
            this.$emit('update-members', bean.current_user.value);
          }

          if (meta.hidden_fields) {
            meta.hidden_fields.forEach(field =>
              this.$set(this.form, field.name, this.formatHtml(field.value))
            );
          }

          meta.panels.forEach(panel => {
            if (
              panel.panel_id == 'LBL_SOCIAL_PACKET_PANEL' ||
              panel.panel_id == 'LBL_PREMIUM_BONUSES_PANEL'
            ) {
              this.$set(this.collapsedPanels, panel.panel_id, true);
            }
            panel.rows.forEach(row => {
              row.forEach(field => this.setField(field, bean));
            });
          });

          meta?.custom_panels?.forEach(panel => {
            if (panel?.switcher_fields == 'email_switcher') {
              let params = panel.uri.split('?');
              let paramsArray = {};
              let param = [];
              for (let elem of params[1].split('&')) {
                param = elem.split('=');
                if (param[0] == 'to_pdf') {
                  paramsArray[param[0]] = Boolean(param[1]);
                } else if (param[0] == 'jsqon_return') {
                  paramsArray[param[0]] = Number(param[1]);
                } else paramsArray[param[0]] = param[1];
              }
              store.commit('subpanels/setEmailData', paramsArray);
              store.commit('subpanels/setEmailParams', this.defaultParams);

              this.$nextTick(() => {
                let form = document.getElementById('email_form');
                let container = document.getElementById('email_switcher');
                container.append(form);
              });
            }
            this.$set(
              this.form,
              panel.switcher_fields,
              bean[panel.switcher_fields]?.value
            );

            if (panel.switcher_fields == 'switcher_files') {
              this.updateDocumentsList();
            }

            panel?.rows?.forEach(row => {
              row.forEach(field => this.setField(field, bean));
            });
          });

          this.metaData = meta;

          if (meta?.buttons_menu) {
            this.$emit('setPopupButtons', meta?.buttons_menu);
          }
          // buttons_menu: meta.buttons_menu || this.buttonsMeta

          if (user_dat_format) {
            this.$set(
              this.datepicker,
              'dateFormat',
              setDateFormat(user_dat_format)
            );
          }

          if (!this.form.layout_form && this.options.layout_form_list) {
            this.$set(
              this.form,
              'layout_form',
              Object.keys(this.options.layout_form_list)[0]
            );
          }

          if (
            this.type &&
            (this.type == 'offer' || this.type == 'employee-exit')
          ) {
            this.fillWithCandidateData();
          }

          if (bean.get_responds && bean.get_responds?.value == 1) {
            this.form.get_responds_date = this.formatDate(
              bean.get_responds_date.value.split(' ')[0],
              this.datepicker.dateFormat
            );
          }

          if (bean.rostrud_integration_error) {
            const { value, options } = bean.rostrud_integration_error;
            if (value && options.hasOwnProperty(value)) {
              this.rabotaRuWarningText = `${options[value].error_message}. ${options[value].req_todo}.`;
            }
          }

          if (
            bean?.another_work_place?.value?.length &&
            bean?.work_site?.value == 'rabotaru'
          ) {
            store.commit('edit/resetAddress', true);
          }

          if (this.form?.work_site == 'trudvsem' && this.form.areas) {
            store.commit('publicator/setTrudvsemCity', this.form.areas);
          }

          if (
            bean?.work_site?.value &&
            bean?.billing_type_id?.value
            /*  || bean?.vacancy_billing_type?.value */
          ) {
            const billingType =
              bean?.billing_type_id
                ?.value; /* || bean?.vacancy_billing_type?.value */
            store.commit('publicator/setBillingType', {
              work_site: bean.work_site.value,
              billingType
            });
          }

          this.processMetadata();
          this.initialForm = Object.assign({}, this.form);
        })
        .catch(err => {
          this.catchError(
            err,
            'Возникла ошибка получения данных',
            'get form data'
          );
          this.$emit('setFormLoading', false);
          if (this.isEmailForm) {
            store.commit('common/setDetachedEmailForm', this.$refs.form);
          }
        })
        .finally(() => {
          this.$nextTick(() => this.resizeDialog());
          setTimeout(() => {
            this.$refs.form.resetFields();
          }, 0);
          this.$emit('setFormLoading', false);
        });
    }
  },
  mounted() {
    if (this.defaultParams.module !== MODULE.HRPAC_PUBLISHED_VACANCY) {
      // отслеживание изменения высоты попапа (изм-е DOM и стилей) с целью фиксации
      // deprecated method, maybe it needs the ResizeObserver
      const dialog =
        this.$parent.$refs.dialog || this.$refs.form.$el.closest('.el-dialog');
      dialog.addEventListener('DOMSubtreeModified', this.resizeDialog, false);
      // bad cross-browser support
      dialog.addEventListener('transitionend', this.resizeDialog, false);

      this.$on('hook:beforeDestroy', () => {
        document.removeEventListener('DOMSubtreeModified', this.resizeDialog);
        document.removeEventListener('transitionend', this.resizeDialog);
      });
    }
  },
  computed: {
    skillsData() {
      return store.state.edit.vacancySkillsData;
    },
    mutationMetaDataPanels() {
      let rows = this.metaData.panels[this.metaData.panels.length - 1].rows;
      const { invite, refuse } = this.inviteAndRefuse;

      if (!Number(this.form.get_responds)) {
        rows.map(item => {
          if (item[0].name === 'mass_vacancy') {
            item[0].disabled = true;
            this.form.mass_vacancy = '0';
          }
          if (item[0].name === 'answer_responds') {
            item[0].disabled = true;
            this.form.answer_responds = '0';
          }
          this.formKey = Date.now();
        });
      } else {
        rows.map(item => {
          if (item[0].name === 'mass_vacancy') {
            item[0].disabled = false;
          }
          if (
            item[0].name === 'answer_responds' &&
            (invite.length || refuse.length)
          ) {
            item[0].disabled = false;
          }
          this.formKey = Date.now();
        });
      }

      return rows;
    },
    requestSent: {
      get() {
        return store.state.common.requestSent;
      },
      set(val) {
        store.commit('common/setRequestState', val);
      }
    },
    inviteAndRefuse() {
      return store.state.vacancy.inviteAndRefuseText;
    },
    resetAddress() {
      return store.state.edit.isResetAddress;
    }
  },
  methods: {
    getIntentHandler(intents) {
      intents.forEach(this.handleIntent)
    },
    handleIntent(intent) {
      if (intent.intentArea == 'Save' && intent.intentType == 'BeanForm') {
        switch (intent.request?.request_params?.mode) {
          case 'preview':
            this.preview(intent);
            break;
          case 'download':
          case 'save_and_download':
            this.downloadFileFromIntent(intent)
            break;
        }
      }
    },
    collapse(id) {
      this.$set(this.collapsedPanels, id, !this.collapsedPanels[id]);
    },
    saveFormFromParent(intents) {
      store.commit('event/setIntents', intents);
      this.parse();
    },
    updateFileList() {
      store.commit('common/setGeneralEmailsFiles', this.files);
    },
    downloadDocument(id) {
      getController({ url: `/index.php?entryPoint=download_spa&id=${id}&type=Notes` })
        .then((resp) => {
          if (resp.data) {
            const { fileData, fileType, fileName } = resp.data;
            const blob = base64ToBlob(fileData, fileType);
            downloadFile(blob, fileName);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    removeDocument(doc) {
      this.removeFile_loading = true;
      if (doc) {
        getController({
          params: {
            module: MODULE.NOTES,
            action: ACTION.DELETE,
            record: doc.id.value
          }
        })
          .then(() => {
            this.updateDocumentsList();
          })
          .catch(err =>
            this.catchError(
              err,
              'Возникла ошибка при удалении документа',
              'document remove'
            )
          );
      }
    },
    updateDocumentsList() {
      getController({
        params: {
          module: MODULE.HRPAC_EVENT,
          action: 'get_event_notes',
          record: this.form.record,
          to_pdf: true
        }
      })
        .then(resp => {
          const format = 'DD.MM.YYYY HH:mm';
          const sortedList = resp.data.List.sort(
            (a, b) =>
              this.rawDate(b.date_modified.value, format) -
              this.rawDate(a.date_modified.value, format)
          );
          this.documents = resp.data.List || sortedList || [];
        })
        .catch(err =>
          this.catchError(
            err,
            'Возникла ошибка обновления списка загруженных документов',
            'documents loading'
          )
        )
        .finally(() => {
          this.removeFile_loading = false;
        });
    },
    setField(field, bean = {}) {
      if (!field.name) return;

      if (
        field.name === 'answer_responds' &&
        (!this.inviteAndRefuse.invite.length ||
          !this.inviteAndRefuse.refuse.length)
      ) {
        field.disabled = true;
      }

      if (field.type == FIELD.TYPE.GROUP) {
        field.fields.forEach(subField =>
          !this.fields[field] ? this.setField(subField, bean) : null
        );
        return;
      } else if (field.blocked && field.type != FIELD.TYPE.GROUP) {
        const blockedFields = Array.isArray(field.blocked)
          ? field.blocked
          : Object.keys(field.blocked);
        blockedFields.forEach(field =>
          !this.fields[field] ? this.setField(bean[field], bean) : null
        );
      }

      if (
        field.name == FIELD.ID.PHONE_NUMBER ||
        field.name == FIELD.ID.CONTACTS_PHONES ||
        field.name == FIELD.ID.CONTACTS_ADDITIONAL_PHONES
      ) {
        field.value = unmaskedPhone(field.value);
      }

      this.$set(this.form, field.name, this.formatHtml(field.value));

      // if (field.name == 'date_event' && this.defaultParams.event_id)
      //   this.$emit('update-date', field.value);
      this.setSpecialRules(field);
      this.fields[field.name] = field;

      if (field.id_name) {
        this.fields[field.id_name.name] = field.id_name;
      }

      if (field.name == 'date_start' || field.name == 'date_end') {
        let dateTimeElements = field.value.split(':');
        if (dateTimeElements.length > 2) {
          field.value = `${dateTimeElements[0]}:${dateTimeElements[1]}`;
        }
      }

      if (
        field.visual_type == 'sub_checkbox' &&
        field.name == FIELD.ID.SPECIALIZATIONS &&
        bean?.work_site?.value == 'rabotaru'
      ) {
        this.formatSpecOptions(field.options || field.option, field);
      }
    },
    setSpecialRules(field) {
      const { name, type, validation, visual_type } = field;
      const rule = this.rules[name] || [];

      if (
        name == FIELD.ID.PHONE ||
        name == FIELD.ID.PHONE_NUMBER ||
        name == FIELD.ID.CONTACTS_PHONES ||
        field.htmlType == 'phone'
      ) {
        rule.push({
          min: 7,
          max: 15,
          message: 'Номер должен содержать как минимум 7 цифр',
          trigger: ['blur', 'focus', 'change']
        });
      } else if (name == FIELD.ID.CONTACTS_EMAIL || field.htmlType == 'email') {
        rule.push({
          type: 'email',
          message: 'Введенный email указан некорректно',
          trigger: ['blur', 'focus', 'change']
        });
      } else if (field.htmlType == 'url' || field.type === FIELD.TYPE.URL) {
        rule.push({
          validator: (rule, value, callback) => {
            const regexp = /^(https?:\/\/)/i;
            if (!regexp.test(value)) {
              callback(new Error('Введен некорректный URL адрес'));
            } else {
              callback();
            }
          },
          trigger: ['blur', 'focus', 'change']
        });
      } else if (!this.dateType(type) && validation && validation.target) {
        const start =
          validation.rules == '<' || validation.rules == '<='
            ? name
            : validation.target;
        const end =
          validation.rules == '>' || validation.rules == '>='
            ? name
            : validation.target;

        rule.push({
          validator: (rule, value, callback) =>
            this.validateNumberRange(true, value, callback, [start, end]),
          // message: 'Неверно введен диапазон чисел',
          trigger: ['blur', 'change']
        });
      } else if (this.dateType(type) && validation && validation.target) {
        const start =
          validation.rules == '<' || validation.rules == '<='
            ? name
            : validation.target;
        const end =
          validation.rules == '>' || validation.rules == '>='
            ? name
            : validation.target;

        rule.push({
          validator: (rule, value, callback) =>
            type == FIELD.TYPE.DATETIME &&
            visual_type == FIELD.VISUAL_TYPE.TIMEPICKER
              ? this.validateTimeRange(
                  true,
                  value,
                  callback,
                  [this.form[start], this.form[end]],
                  this.datepicker.timeFormat,
                  start == FIELD.ID.CALL_TIME_FROM &&
                    end == FIELD.ID.CALL_TIME_TO
                )
              : this.validateDateRange(
                  true,
                  value,
                  callback,
                  [this.form[start], this.form[end]],
                  this.datepicker.dateFormat
                ),
          // message: 'Неверно введен диапазон дат',
          trigger: ['blur', 'change']
        });
      } else if (this.textType(type)) {
        rule.push({
          validator: (rule, value, callback) => {
            const validLength = field.minlength
              ? value.replace(/<\/?[^>]+(>|$)/g, '').length >= field.minlength
              : true;

            if (!validLength)
              callback(
                new Error(
                  `Минимальная длина сообщения ${field.minlength} символов`
                )
              );
            else callback();
          },
          trigger: ['blur', 'change']
        });
      }

      this.$set(this.rules, name, rule);
      if (!this.$refs.form) return;
      this.$refs.form.validate();
    },
    async validateForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid, fields) => {
          if (!valid) {
            store.commit('common/setClickSaveform', false);
            const errorFields = Object.keys(fields).map(
              field => this.fields[field]
            );
            const wrapperEl =
              this.$refs.form.$el.closest(
                '.dialog--scrollable .el-dialog__body'
              ) ||
              this.$refs.form.$el.closest('.dialog') ||
              window;
            scrollToError(
              errorFields,
              wrapperEl,
              this.defaultParams.module == MODULE.HRPAC_PUBLISHED_VACANCY
                ? `#pane-${this.specialParam}`
                : null
            );
          } else {
            resolve();
          }
        })
      });
    },
    downloadFileFromIntent(intent) {
      this.validateForm()
        .then(() => {
          return this.sendFormRequestFromIntent(intent, this.form)
        })
        .then((resp) => {
          if (resp.data) {
            const { fileData, fileType, fileName } = resp.data;
            const blob = base64ToBlob(fileData, fileType);
            downloadFile(blob, fileName);
          } else {
            this.catchError('Возникла ошибка скачивания файла');
          }
        })
        .catch((err) => {
          this.catchError(err, 'Возникла ошибка скачивания файла');
        });
    },
    async preview(intent) {
      this.$set(this.defParams, 'mode', 'preview');
      this.btnLoading.preview = true;

      this.sendFormRequestFromIntent(intent, this.form)
        .then((resp) => {
          if (resp.data) {
            const { fileData, fileType } = resp.data;
            const blob = base64ToBlob(fileData, fileType);
            const name = `Предпросмотр сформированно${this.type === 'offer' ? 'го оффера' : 'й заявки'}`;
            previewFile(blob, name);
          }
          if (resp.data?.errors && resp.data.errors?.length) {
            this.showErrorMessage(resp.data.errors);
          }
        })
        .catch((err) => {
          this.catchError(
            err,
            `Возникла ошибка предпросмотра ${
              this.type === 'offer' ? 'оффера' : 'заявки на выход сотрудника'
            }. Попробуйте еще раз.`,
            `preview ${this.type === 'offer' ? 'offer' : 'employee exit'} form`
          );
        })
        .finally(() => {
          this.requestSent = false;
          this.btnLoading.preview = false;
          this.$delete(this.defParams, 'mode');
        })
    },
    fillWithCandidateData() {
      if (!this.data) return;

      Object.values(this.fields).forEach(field => {
        const prop = field.name;
        const { candidates_data, vacancy_data } = this.data;
        const communications = candidates_data.communications;
        const phoneIndex =
          communications &&
          communications.findIndex(({ value_type }) => value_type === prop);
        const excludedFields = [FIELD.ID.DESCRIPTION, FIELD.ID.GRADE];
        if (
          candidates_data.hasOwnProperty(prop) &&
          !excludedFields.includes(prop) &&
          !field.value
        ) {
          this.$set(this.form, prop, this.formatHtml(candidates_data[prop]));
        }

        if (
          vacancy_data.hasOwnProperty(prop) &&
          !excludedFields.includes(prop) &&
          !field.value
        ) {
          this.$set(this.form, prop, this.formatHtml(vacancy_data[prop]));
        }

        if (phoneIndex > -1) {
          const phoneVal = unmaskedPhone(
            this.formatHtml(communications[phoneIndex].value)
          );
          this.$set(this.form, prop, phoneVal);
        }
      });
    },
    selectTemplate(templateId) {
      this.$emit('setFormLoading', true);
      const formData = new FormData();
      let eventForm = this.$refs.form?.$parent?.$parent?.$parent?.model || {};

      if (eventForm && Object.keys(eventForm)?.length) {
        formData.set(
          'additional_parents',
          JSON.stringify({
            HRPAC_VACANCY: [eventForm.hrpac_vacancy_id || ''],
            HRPAC_CANDIDATES: [eventForm.hrpac_candidate_id || '']
          })
        );
        formData.set(
          'parent_data',
          JSON.stringify({
            name: eventForm.name || '',
            place_event: eventForm.place_event || '',
            description: eventForm.description || '',
            date_event: eventForm.date_event || '',
            date_start: eventForm.date_start || '',
            date_end: eventForm.date_end || ''
          })
        );
      } else if (store.state.rightPanel.vacancyId) {
        formData.set(
          'additional_parents',
          JSON.stringify({
            HRPAC_VACANCY: [store.state.rightPanel.vacancyId]
          })
        );
      }
      formData.set('parent_type', this.defaultParams?.parent_type || '');
      formData.set('parent_id', this.defaultParams?.parent_id || '');

      postController({
        url: `/index.php?entryPoint=emailTemplateData&emailTemplateId=${templateId}&to_pdf=true`,
        options: formData
      })
        .then(resp => {
          const { data, error } = resp.data;

          if (error) {
            this.showErrorMessage(error);
            return;
          }

          if (data.multiple_values) {
            this.showNotification({
              offset: 100,
              showClose: true,
              message: `Для некоторых переменных найдено несколько значений. Оставьте нужные варианты`,
              duration: 10000,
              type: 'warning'
            });
          }

          if (!data || !data.field_mapping) return;

          for (let key in data.field_mapping) {
            if (key != 'attachments') {
              this.$set(
                this.form,
                data.field_mapping[key],
                this.formatHtml(data[key] || '')
              );
            } else {
              this.$emit('set-template-files', data[key]);
            }
          }
        })
        .catch(err => {
          this.catchError(
            err,
            'Возникла ошибка выбора шаблона письма',
            'select email template'
          );
        })
        .finally(() => {
          this.$emit('setFormLoading', false);
        });
    },
    async addNewSkill(name, type) {
      if (this.requestSent || !this.skills[name]) return;
      this.requestSent = true;
      this.fieldLoading = true;

      await store.dispatch('edit/addNewSkill', {
        name,
        skills: this.skills,
        type
      });

      this.fieldLoading = false;

      if (this.fields[name].id_name) {
        this.$set(this.form, this.fields[name].id_name, this.skillsData);
        this.$set(this.form, name, this.skills[name]);
      } else {
        if (Array.isArray(this.form[name])) {
          this.form[name].push(this.skillsData);
        } else {
          this.form[name] = [this.skillsData];
        }
      }
      this.$refs.form.validateField(name);

      const newOption = {
        id: this.skillsData,
        name: this.skills[name]
      };

      if (!this.options[name]) this.$set(this.options, name, []);
      this.options[name].push(newOption);
      this.skills[name] = '';
      this.visibleSkillBtn = false;
      this.requestSent = false;
    },
    handleChangeSkill(val, name, limit /* , access */) {
      // if (!access) return;

      if (limit && this.form[name].length === limit) {
        val = '';
        this.visibleSkillBtn = false;
      } else {
        const formatStr = str => str.toLowerCase().trim();
        const options =
          this.fields[name].options &&
          typeof this.fields[name].options == 'object'
            ? Object.keys(this.fields[name].options).map(key => ({
                id: key,
                name: this.fields[name].options[key]
              }))
            : store.state.common.newOptions[name];
        const query = !options.find(
          skill => formatStr(skill.name) === formatStr(val)
        );
        this.$set(this.skills, name, val);
        this.visibleSkillBtn = val ? query : false;
      }
    },
    handleBlur(visible, name) {
      if (!visible) {
        this.skills[name] = '';
        this.visibleSkillBtn = false;
        this.skillsData = '';
      }
    }
  },
  watch: {
    resetAddress() {
      if (this.resetAddress) {
        this.$delete(this.rules, FIELD.ID.WORK_PLACE);
      } else {
        this.setRequiredFields(true, FIELD.ID.WORK_PLACE);
      }
      this.$nextTick(() => {
        this.$refs.form.validateField(FIELD.ID.WORK_PLACE);
      });
    },
    'form.need_coordination'(newVal) {
      this.$emit('need-coordination', newVal);
    }
  },

  components: {
    'el-form': Form,
    FormField,
    FormButtons,
    Switcher,
    SubpanelTable,
    Button,
    Upload,
    Picture,
    Tooltip,
    Icon
  }
};
</script>

<style lang="scss" scoped>
.rabota-ru-warning {
  display: flex;
  margin-top: 8px;
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: 4px;
  background-color: $yellow16;
  font-size: 16px;
  line-height: 24px;
  color: $grey80;
  word-break: break-word;

  svg {
    margin-right: 8px;
  }
}

label {
  text-align: left;
  color: $black-200;
  font-weight: normal;
}

.block-img {
  margin: 0 8px 12px;
  rotate: 180deg;
  filter: brightness(0) saturate(100%) invert(74%) sepia(4%) saturate(1132%)
    hue-rotate(172deg) brightness(89%) contrast(84%);
}

.label {
  line-height: 24px;
  font-weight: normal;
  padding: 0;
  text-align: left;
  word-break: break-word;
  white-space: normal;
}

.red-star {
  width: 9px;
  height: 8px;
  display: inline-block;
  background-image: url(/front/public/style/img/required-star.svg);
  background-repeat: no-repeat;
  background-position: 50%;
  margin-left: 7px;
}

// .form-panel + .form-panel {
//   margin-top: 28px;
// }

.form {
  &-panel {
    margin-bottom: 32px;

    &--special ::v-deep {
      .el-form-item__content {
        line-height: 32px;
      }

      .panel-row--switch:first-child {
        padding-top: 0 !important;
      }

      .panel-row {
        margin-bottom: 0 !important;
      }

      .answer-responds__label {
        margin-top: 0;
        margin-bottom: 0;
      }

      .panel-row--switch + .panel-row--switch {
        margin-top: 16px !important;
      }

      .answer-responds__label {
        margin-top: 0;
      }

      .el-form-item__label {
        line-height: 24px !important;
        margin-top: 8px;
      }
    }

    &__arrow {
      margin-left: auto;
      cursor: pointer;
    }
  }
}

.panel {
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-color: $black-10;
  border-radius: 4px;

  &__header {
    display: flex;
    gap: 16px;
  }

  &__label {
    color: $black-200;
    font-size: 16px;
    line-height: 24px;
  }
}

.custom-panels {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;

  &__switcher {
    display: flex;
    width: 100%;
  }

  &__row {
    &:not(:last-of-type) {
      margin-bottom: 0 !important;
    }

    margin-top: 16px;
  }

  &__item {
    display: block;
    padding: 16px;
    gap: 16px;
    background-color: $grey8;
    border-radius: 4px;

    .documents-list {
      padding-top: 8px;

      // .documents__list {
      //   padding-top: 8px;
      // }
      & ::v-deep .document {
        background: white;

        &__row-delete {
          display: block;
        }
      }
    }
  }

  &__label {
    color: $black-200;
  }
}

.form-custom {
  display: flex;
  flex-direction: column;
  background-color: $black-10;
  border-radius: 4px;
  // margin-top: 8px;
  padding: 16px;

  &__switcher {
    display: flex;
    gap: 20px;
    align-items: center;

    &--label {
      color: $black-200;
      font-size: 16px;
      line-height: 24px;
    }
  }
}

.panel-row {
  display: flex;
  justify-content: space-between;

  & > .email-attachment {
    width: 100%;
  }

  &:not(:last-of-type) {
    margin-bottom: 12px;
  }

  &:empty {
    display: none;
  }

  &__column {
    width: calc(50% - 4px);

    & ::v-deep .form-field {
      div {
        .el-form-item {
          .el-form-item__content {
            display: flex;
            flex-direction: column !important;
          }
        }
      }
    }
  }

  & ::v-deep > .form-field {
    &:not(:only-child):first-child {
      margin-right: 24px;
      width: calc(50% - 12px);
    }

    &:not(:only-child):last-child {
      width: calc(50% - 12px);
    }

    &:only-child {
      width: 100%;
    }
  }

  & ::v-deep .el-form-item {
    width: 100%;

    &__label {
      padding: 0;
      left: 0;
      top: 100%;
    }

    &__error {
      position: relative;
      padding: 0;
      left: 0 !important;
      top: 100% !important;
      text-align: left;
    }

    &__content {
      margin-left: 0;
      width: 100%;
    }
  }

  & ::v-deep .el-switch__label span {
    font-size: 16px;
    line-height: 24px;
    color: $primary-text;
  }

  & ::v-deep .el-switch,
  & ::v-deep .el-switch__label {
    height: 24px;
  }
}

.el-form {
  &.el-form--label-top ::v-deep .el-form-item {
    &__content {
      flex-direction: column;
    }

    &.sub-fields > .el-form-item__content {
      flex-direction: row;
    }
  }

  &.el-form--label-left {
    & ::v-deep .panel-row {
      align-items: center;
    }

    & ::v-deep .el-form-item {
      &__content {
        flex-direction: row;
      }

      &__label {
        white-space: nowrap;
        min-width: 115px;
        margin-right: 16px;
      }
    }
  }
}

.el-form {
  &.el-form--label-top ::v-deep .el-form-item {
    &__content {
      flex-direction: column;
    }
  }

  &.el-form--label-left {
    & ::v-deep .panel-row {
      align-items: center;
    }

    & ::v-deep .el-form-item {
      &__content {
        flex-direction: row;
      }

      &__label {
        white-space: nowrap;
        min-width: 115px;
        margin-right: 16px;
      }

      &__error {
        display: none !important;
      }
    }
  }
}

.block-title {
  color: $grey64;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  text-align: left;
  margin-bottom: 8px;
  margin-top: 20px;
}

#front .el-dialog__wrapper .footer {
  &__row {
    display: flex;
  }

  &__button {
    width: auto;

    &:nth-child(2) {
      margin-left: 12px;
    }
  }
}

.dialog__content .el-form .buttons-panel {
  display: flex;
  margin-top: 16px;
  flex-wrap: wrap;
  align-items: center;
}
</style>
